<template>
  <div class="main">
    <div>
      <h1>AI-Alerter</h1>
      <h3>完善用户信息</h3>

      <el-form ref="ruleForm" status-icon :model="ruleForm" :rules="rules" label-width="80px" label-position="top">

        <el-form-item label="用户名" prop="username">
          <el-input :disabled="true" v-model="ruleForm.username" placeholder="请尽量使用名字的拼音做用户名"></el-input>
        </el-form-item>

        <!--        <el-form-item label="密码" prop="pass">-->
        <!--          <el-input type="password" v-model="ruleForm.pass" autocomplete="off" placeholder="密码至少6位数"></el-input>-->
        <!--        </el-form-item>-->
        <!--        <el-form-item label="确认密码" prop="checkPass">-->
        <!--          <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off" placeholder="密码至少6位数"></el-input>-->
        <!--        </el-form-item>-->

        <el-form-item label="手机号码" prop="phone">
          <el-input v-model="ruleForm.phone" placeholder="请确保手机号码正确，系统暂时不支持发送验证码验证"></el-input>
        </el-form-item>

        <el-form-item label="邮箱" prop="email">
          <el-input v-model="ruleForm.email" placeholder="请确保邮箱正确，系统暂时不支持发送验证码验证"></el-input>
        </el-form-item>

        <el-form-item label="wpsID" prop="wpsID">
          <div>
            <el-input v-model="ruleForm.wpsID" placeholder="wps中唯一的用户ID"></el-input>

            <a href="https://www.kdocs.cn/l/cueLYPYVmtxP" target="_Blank">获取wpsID</a>

          </div>

        </el-form-item>


        <el-form-item class="register-btn">
          <el-button style="width: 190px" type="primary" size="medium" @click="register">确认</el-button>
          <el-button style="width: 190px" type="info" size="medium" @click="resetForm('ruleForm')">重置</el-button>

        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import {Apis} from "@/api";

export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value.length < 6) {
        callback(new Error('密码至少6位数'));
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('username');
        }
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      ruleForm: {
        username: '',
        // pass: '',
        // checkPass: '',
        phone: '',
        email: '',
        wpsID: "",
      },
      rules: {
        pass: [
          {validator: validatePass, trigger: 'blur'}
        ],
        checkPass: [
          {validator: validatePass2, trigger: 'blur'}
        ]
      }
    };
  },
  methods: {
    async register() {
      if (this.ruleForm.username === "" || this.ruleForm.phone === "" || this.ruleForm.email === "" || this.ruleForm.wpsID === "") {
        this.$message.error("用户名，手机号码，邮箱，wpsID，都不能为空");
        return
      }
      const userID = this.$cookies.get("userID")
      if (userID === undefined) {
        this.$message.error("无法从cookie中获取userID");
        return
      }
      const response = await Apis.User.update(parseInt(userID), this.ruleForm.phone, this.ruleForm.email, this.ruleForm.wpsID);
      // console.log(response);

      if (response != null && response.errno === 0) {
        this.$message.success("完善信息成功!")
        //移除所有cookie 方便管理
        this.$cookies.remove("openID")
        this.$cookies.remove("token")
        this.$cookies.remove("userID")
        this.$cookies.remove("userName")
        console.log("完善信息页面：cookie是否清除完毕：", this.$cookies.keys())

        await this.$router.push({name: "Login"})
        this.$router.go(0)

      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  created() {
    const userName = this.$cookies.get("userName")
    if (userName === undefined) {
      this.$message.error("无法从cookie中获取userName");
      return
    }
    this.ruleForm.username = userName

  }
}
</script>

<style scoped>
h1 {
  text-align: center;
}

.main {
  display: flex;
  justify-content: center;
}

.register-btn {
  text-align: center;
}

</style>